__webpack_require__.p = "//personal-page-video-front.staging.it-incubator.ru/";